import Vue from 'vue'
import Router from 'vue-router'
import Catalog from '@/components/Catalog'
import Sales from '@/components/Sales'
import Information from '@/components/Information'
import CRM from '@/components/CRM'
import Order from '@/components/Order'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/catalog',
      name: 'Catalog',
      component: Catalog,
      props: true,
      alias: '/'
    },
    {
      path: '/sales',
      name: 'Sales',
      component: Sales,
      props: true,
      alias: '/'
    },
    {
      path: '/information',
      name: 'Information',
      component: Information,
      props: true,
      alias: '/'
    },
    {
      path: '/CRM',
      name: 'CRM',
      component: CRM,
      props: true,
      alias: '/'
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order,
      props: true,
      alias: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js